import { EDDQuestionnaire } from "../components/EDDQuestionnaire/EDDQuestionnaire";
import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const AdditionalInformation: React.FC<FlowStep> = ({
  title,
  onNext,
  onSkip
}) => {
  return (
    <EDDQuestionnaire onSubmit={onNext} onCancel={onSkip} isLoading={false} />
  );
};
